import { action, type Action } from 'easy-peasy';
import { CollapseType } from '@meitu/saas-editor-ui';

export interface IBrushCollapseModel {
    /**
     * 来源信息
     */
    from: CollapseType | null;

    /**
     * 设置来源信息
     */
    setFrom: Action<IBrushCollapseModel, CollapseType | null>;
}

export const brushCollapseModel: IBrushCollapseModel = {
    from: null,

    setFrom: action((state, payload) => {
        state.from = payload;
    }),
};
